<template>
  <div class="MobileGeneral">
    <div class="mobile-header">
      <b-button class="BtnRegister" @click="handleModals('venda')">
        <b-icon-plus
          scale="1.5"
          style="
            width: 30px;
            background: #006458;
            height: 30px;
            color: white;
            border-radius: 2px;
          "
        ></b-icon-plus>
        <span style="width: 170px">Nova Venda </span>
      </b-button>
    </div>

    <transition name="slide-fade">
      <div v-if="showFilters" class="mobile-filters-container">
        <div class="filter-row">
          <label>Período:</label>
          <div class="date-group">
            <input type="date" v-model="startDate" />
            <span class="date-separator">até</span>
            <input type="date" v-model="endDate" />
          </div>
        </div>

        <div class="filter-row">
          <b-form-select
            v-model="type"
            :options="filterCombobox"
            size="sm"
            class="mobile-select"
          ></b-form-select>
        </div>

        <div class="filter-row search-row">
          <b-input
            v-model="textPesquisa"
            placeholder="Buscar..."
            class="mobile-search-input"
            @keyup.enter="filterSale(page)"
          ></b-input>
          <b-button @click="filterSale(page)" class="btn-search-mobile">
            <b-icon-search></b-icon-search>
          </b-button>
        </div>
      </div>
    </transition>

    <div class="status-scroll-container">
      <div class="status-card draft" @click="handleTypeSale('rascunho')">
        <span class="status-label">Rascunhos</span>
        <span class="status-count">{{ this.countRascunho }}</span>
      </div>
      <div class="status-card finalized" @click="handleTypeSale('finalizado')">
        <span class="status-label">Finalizadas</span>
        <span class="status-count">{{ this.countFinalizado }}</span>
      </div>
      <div class="status-card canceled" @click="handleTypeSale('cancelado')">
        <span class="status-label">Canceladas</span>
        <span class="status-count">{{ this.countCancelado }}</span>
      </div>
    </div>

    <div class="header-actions">
      <b-button class="btn-toggle-filters" @click="showFilters = !showFilters">
        <b-icon-funnel-fill></b-icon-funnel-fill>
      </b-button>
    </div>

    <div class="card-list-container">
      <div
        v-for="dataSearchSale in dataSale"
        :key="dataSearchSale.id"
        class="sale-card"
        @click="editSales(dataSearchSale)"
      >
        <div class="card-header-mobile">
          <span class="receipt-id">#{{ dataSearchSale.numero || 0 }}</span>
          <span class="receipt-date">{{
            dataSearchSale.data.split("-").reverse().join("/")
          }}</span>
          <span class="status-indicator"></span>
        </div>

        <div class="card-body-mobile">
          <div class="info-group">
            <label>Cliente :</label>
            <strong>{{
              dataSearchSale.nomeCliente || "CONSUMIDOR FINAL"
            }}</strong>
          </div>
          <div class="info-group">
            <label>Funcionário :</label>
            <span>{{ dataSearchSale.nomeFuncionario || "Não informado" }}</span>
          </div>
        </div>

        <div class="card-actions-mobile">
          <b-button
            variant="link"
            class="action-btn"
            @click.stop="
              printCouponOrA4(dataSearchSale.tipo, dataSearchSale.id)
            "
          >
            <b-icon-printer-fill></b-icon-printer-fill> Imprimir
          </b-button>

          <b-button
            variant="link"
            class="action-btn"
            @click.stop="getIdSaleDetails(dataSearchSale.id)"
            v-b-modal.modal-center4
          >
            <b-icon-eye></b-icon-eye> Detalhes
          </b-button>

          <b-dropdown variant="link" no-caret class="action-dropdown" right>
            <template #button-content>
              <b-icon-three-dots-vertical></b-icon-three-dots-vertical>
            </template>
            <b-dropdown-item @click.stop="editSales(dataSearchSale)"
              >Editar</b-dropdown-item
            >
            <b-dropdown-item
              v-if="
                dataSearchSale.idNota === null &&
                dataSearchSale.tipo === 'Pedido'
              "
              @click.stop="sendCoupon(dataSearchSale.id)"
            >
              Emitir NFC-e
            </b-dropdown-item>
            <b-dropdown-item
              v-if="
                dataSearchSale.idNota === null &&
                dataSearchSale.tipo === 'Pedido'
              "
              @click.stop="transformToNfe(dataSearchSale.id)"
            >
              Emitir NF-e
            </b-dropdown-item>
            <b-dropdown-item
              v-if="dataSearchSale.idNota !== null"
              @click.stop="
                handleOpenModalAndFindFiscalDocument(
                  'modal-cancel',
                  dataSearchSale
                )
              "
            >
              {{
                String(dataSearchSale.modelosNota) === "2"
                  ? "Cancelar NFC-e"
                  : "Cancelar NF-e"
              }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="dataSearchSale.tipo === 'Pedido'"
              @click.stop="openModalDropSale(dataSearchSale.id)"
              variant="danger"
            >
              Excluir
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <div v-if="!dataSale.length" class="empty-state">
        <b-icon-inbox scale="2"></b-icon-inbox>
        <p>Nenhum pedido encontrado.</p>
      </div>
    </div>

    <!-- Modals -->
    <b-modal
      id="modal-center4"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Detalhes"
    >
      <div class="closeModalDetails" @click="$bvModal.hide('modal-center4')">
        X
      </div>
      <div class="contentModal">
        <span><b-icon-file-text></b-icon-file-text> Informações Básicas</span>
        <div class="rowModal">
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="this.detailsSales.data"
            />
            <label class="user-label">Data</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.numero"
            />
            <label class="user-label">Nº Operação</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.status"
            />
            <label class="user-label">Status</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeCliente"
            />
            <label class="user-label">Cliente</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.cpfCnpj"
            />
            <label class="user-label">CPF/CNPJ</label>
          </div>
          <div class="input-group-supplier">
            <input
              disabled
              class="input borderInput"
              v-model="detailsSales.nomeFuncionario"
            />
            <label class="user-label">Funcionário</label>
          </div>
        </div>
      </div>
      <div class="contentModal">
        <span><b-icon-box-seam></b-icon-box-seam> Produtos</span>
        <div class="rowModal">
          <table style="border-spacing: 1px 0; width: 100%">
            <thead
              style="
                color: whitesmoke;
                background: #3a4750;
                padding: 10px;
                height: 35px;
                text-align: center;
                border-spacing: 0;
              "
            >
              <tr>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Observação</th>
                <th>Qtd</th>
                <th>Valor Unitário</th>
                <th>Desconto</th>
                <th>Valor Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="detailsSale in this.detailsSales.products"
                :key="detailsSale.id"
                style="
                  text-align: center;
                  height: 60px;
                  border-bottom: 1px solid rgb(218, 218, 218);
                "
              >
                <td>{{ detailsSale.nome }}</td>
                <td>{{ detailsSale.tipoProduto }}</td>
                <td>{{ detailsSale.dadosAdicionais || "--" }}</td>
                <td>{{ detailsSale.quantidade }}</td>
                <td>{{ detailsSale.valorUnitario }}</td>
                <td>{{ detailsSale.desconto || "--" }}</td>
                <td>{{ detailsSale.valorTotal }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modal-cancel"
      hide-footer
      hide-header
      centered
      title="Cancelar"
    >
      <div>
        <h4 class="titleModal" style="text-align: center">
          Deseja cancelar essa {{ nameFiscalDocument }} ?
        </h4>
        <div class="btnModalCancel">
          <div class="contentMotivo">
            <label>Descreva o motivo do cancelamento:</label> <span>*</span>
            <b-form-textarea
              placeholder="Min: 15 caracteres"
              style="color: black; width: 100% !important"
              v-model="motivo"
            ></b-form-textarea>
          </div>
          <div class="contentBtns">
            <button class="btnContent" @click="cancelNota()">
              Cancelar {{ nameFiscalDocument }}
            </button>
            <button
              class="btnContentReceive"
              @click="$bvModal.hide('modal-cancel')"
            >
              Não, Obrigado!
            </button>
          </div>
        </div>
        <span class="alertCancel">
          O prazo máximo para cancelamento de uma {{ nameFiscalDocument }} é de
          até {{ textTimeToCancel }} após a concessão da autorização de uso.
        </span>
      </div>
    </b-modal>

    <div :class="sizeModal">
      <div :class="modalContainer" v-if="colapseModal">
        <b-button class="closeModalPurchase" @click="modalHeight">
          Fechar
        </b-button>
        <MobilePrescription
          v-if="this.typeDocument.venda"
          :typeComponent="outsideTypeSale"
        />
      </div>
    </div>

    <Loading v-if="spinLoading" :text="textToModalLoading" />

    <ModalConfirm
      modalName="drop-sale"
      title="Deseja realmente excluir ?"
      subtitle="Atenção! Esta ação não poderá ser desfeita. Ao confirmar, o registro e todas as parcelas financeiras associadas serão excluídos permanentemente."
      rightButtonText="Sim"
      leftButtonText="Não excluir"
      typeModal="danger"
      headerIcon="b-icon-exclamation-triangle-fill"
      :rightButtonClick="deleteSale"
    />
  </div>
</template>

<script>
import { DateTime } from "luxon";
import { mapMutations, mapState } from "vuex";
import api from "../../services/axios";

import MobilePrescription from "../Prescription/MobilePrescription.vue";
import Loading from "../Loading/Loading.vue";
import ModalConfirm from "../Modals/ModalConfirm.vue";

import ServiceSale from "../../services/serviceSale";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";

import { TypeSale } from "../../utils/enums/SalesType";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { TypesOfSales } from "../../utils/enums/TypesOfSales";
import toastAlertErros from "../../utils/toastAlertErros";
import { HandleErrors } from "../../utils/handleErrors";
import printReport from "../../reports/sale";
import { formatValuesFromSales } from "../../helpers/generalSales";

export default {
  components: {
    MobilePrescription,
    Loading,
    ModalConfirm,
  },
  props: {
    initialMonth: {
      type: Date,
      default: () => new Date(),
    },
    outsideTypeSale: {
      type: String,
      default: "Pedido",
    },
  },
  data() {
    return {
      year: DateTime.local().year,
      month: DateTime.local(),
      typeSale: TypeSale,
      spinLoading: false,
      spinGeneral: false,
      textPesquisa: "",
      type: "",
      typeOfSales: TypesOfSales.normal,
      typeSituation: "",
      startDate: "",
      endDate: "",
      colapseModal: false,
      modalContainer: "contentModalDisable",
      dataSale: [],
      totalMonth: 0,
      totalMonthSale: 0,
      totalcancelado: 0,
      countCancelado: 0,
      countFinalizado: 0,
      countRascunho: 0,
      totalfinalizado: 0,
      totalrascunho: 0,
      dataBills: "",
      page: 1,
      dataLength: 0,
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "nomeFuncionario", text: "Funcionário" },
        { value: "numero", text: "Nº Operação" },
        { value: "", text: "Selecione..." },
      ],
      saleId: "",
      detailsSales: { products: [], bills: [] },
      returnDataNote: null,
      motivo: "",
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      itemSelectedInTableSearch: null,
      textToModalLoading: "",
      showFilters: false,
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "ALTER_TYPE_DOCUMENT",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
      "SET_DATA_SEARCH_FROM_SALE",
      "SET_DATA_NFE",
      "SET_ID_TRANSFORM_COMPLETED_SALE",
    ]),

    async getIdSaleDetails(idSale) {
      this.detailsSales = await this.findCompletedSale(idSale);
      this.saleId = idSale;

      const dataSalesFormated = this.detailsSales.data
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");

      this.detailsSales.data = dataSalesFormated;
    },

    async deleteSale() {
      try {
        this.spinGeneral = true;
        await ServiceSale.deleteAll(this.saleId);

        await this.filterSale(1);
        await this.filterSalePerMonth();
        this.$bvModal.hide("drop-sale");
        return this.$toast.open({
          message: "Pedido removido com sucesso!",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;
        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else toastAlertErros.validateMessage(error, this.$toast);
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterSale(page) {
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/sales?q=${this.textPesquisa}&type=${this.type}&page=${page}&startDate=${this.startDate}&endDate=${this.endDate}&typeSale=${this.outsideTypeSale}`
        );

        if (!Object.keys(data).length) {
          return;
        }

        this.dataLength = data.data.length;
        this.dataSale = data.data.map((sale) => {
          if (sale.bills.length) {
            const totalPago = sale.bills?.reduce(
              (sum, bill) => sum + bill.valorPago,
              0
            );
            return { ...sale, totalPago };
          }

          return sale;
        });
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao buscar informações",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    handleTypeSale(name) {
      this.type = "status";
      this.textPesquisa = name;

      this.filterSale(1);
    },

    async filterSalePerMonth() {
      try {
        const result = await ServiceSale.filterSalePerMonth(
          this.month.month,
          this.year,
          this.outsideTypeSale
        );

        if (result && Object.keys(result).length) {
          this.countCancelado = result.countCancelado;
          this.countFinalizado = result.countFinalizado;
          this.countRascunho = result.countRascunho;

          this.totalcancelado = result.cancelado;
          this.totalfinalizado = result.finalizado;
          this.totalrascunho = result.rascunho;
        }
      } catch (error) {
        console.log(error);
      }
    },

    nextPage() {
      this.filterSale((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.filterSale((this.page -= 1));
      }
    },

    async modalHeight() {
      this.colapseModal = !this.colapseModal;
      this.colapseModal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");
      this.modalContainer = this.modalContainer
        ? "modalContainer"
        : "contentModalDisable";

      if (!this.colapseModal && this.sizeModal === "disable") {
        this.SET_DATA_SEARCH_FROM_BOX_FRONT({});
        this.SET_DATA_SEARCH_FROM_SALE({});
      }
      await this.filterSalePerMonth();
      this.filterSale(1);
    },

    async editSales(sale) {
      const data = await this.searchTableDataForSale(sale.id);

      if (data && Object.keys(data).length) {
        this.handleEditSale(data);
      }
    },

    async searchTableDataForSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    async findCompletedSale(idVenda) {
      try {
        const { data } = await api.get(`/sales/details/${idVenda}`);
        return data;
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um erro ao editar",
          type: "info",
        });
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_DOCUMENT(name);

      this.modalHeight();
    },

    handleEditSale(data) {
      if (this.outsideTypeSale !== "Pedido") data.tipo = "Receita Pedido";

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    async transformToNfe(idSale) {
      try {
        let dataNFe;
        dataNFe = await ServiceSale.transformInNotaToSend(idSale);

        this.SET_DATA_NFE(dataNFe);

        this.$toast.open({
          message: "Pedido transformado em nota fiscal!",
          type: "success",
        });

        this.$router.push({
          path: `/fiscal`,
        });
      } catch (error) {
        if (
          error?.response?.data?.message &&
          error?.response?.data?.message?.includes("Validation failed")
        ) {
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        }

        return toastAlertErros.validateMessage(error, this.$toast);
      }
    },

    async sendCoupon(idSale) {
      try {
        this.spinLoading = true;
        this.textToModalLoading = "Aguarde! O Seu cupom está sendo emitido !";

        const data = await ServiceNotaFiscal.sendCoupon(idSale);
        this.responseNfeWebMania.danfe = await data.dataWebMania.danfe;
        this.visualizarNfe(this.responseNfeWebMania.danfe);

        await this.filterSale(1);
        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
      }
    },

    openModalDropSale(saleId) {
      this.saleId = saleId;
      this.$bvModal.show("drop-sale");
    },

    printReportReceipt(idSale) {
      printReport("receiptStandard", idSale);
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    async findNotaById(idNota) {
      this.returnDataNote = await ServiceNotaFiscal.findNotaById(idNota);
    },

    async cancelNota() {
      try {
        const dataCancelamento = {
          uuid: this.returnDataNote.response.uuid,
          motivo: this.motivo,
        };
        this.spinLoading = true;
        this.textToModalLoading =
          "Aguarde! O Seu documento fiscal está sendo cancelado !";

        await ServiceNotaFiscal.cancelNota(
          dataCancelamento,
          this.returnDataNote.id
        );

        this.$toast.open({
          message: `${this.nameFiscalDocument} cancelada!`,
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message: "Houve um erro! Verifique e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
        this.textToModalLoading = "";
        this.motivo = "";
      }
    },

    printCouponOrA4(type, idSale) {
      if (type === this.typeSale.frenteDeCaixa) {
        this.printReportCoupon(idSale);
      } else {
        this.printReportVendaOrcamento(idSale);
      }
    },

    printReportCoupon(idSale) {
      printReport("reportCoupon", idSale);
    },

    printReportVendaOrcamento(idSale) {
      printReport("reportVendaOrcamento", idSale);
    },

    async handleOpenModalAndFindFiscalDocument(nameModal, dataSearchSale) {
      this.itemSelectedInTableSearch = dataSearchSale;
      this.findNotaById(dataSearchSale.idNota);
      this.openModal(nameModal);
    },

    openModal(nameModal) {
      this.$bvModal.show(nameModal);
    },

    openModalVenda() {
      this.ALTER_TYPE_DOCUMENT("venda");
      this.modalHeight();
    },

    delayToOpen() {
      setTimeout(() => {
        this.openModalVenda();
      }, 500);
    },
  },
  computed: {
    ...mapState({
      sizeModal: (state) => state.sizeModal,
      typeDocument: (state) => state.typeDocument,
      idTransformCompletedSale: (state) => state.idTransformCompletedSale,
    }),
    monthName() {
      return this.month.toLocaleString({ month: "long", locale: "pt-BR" });
    },
    nameFiscalDocument() {
      return String(
        this.itemSelectedInTableSearch?.modelosNota ||
          this.returnDataNote?.modelo
      ) === "2"
        ? "NFC-e"
        : "NF-e";
    },
    textTimeToCancel() {
      return this.nameFiscalDocument === "NFC-e"
        ? "30 MINUTOS"
        : "24 HORAS";
    },
  },
  async created() {
    this.startDate = DateTime.now().startOf("month").toISODate();
    this.endDate = DateTime.now().endOf("month").toISODate();

    this.filterSale(1);
    await this.filterSalePerMonth();
    this.ALTER_SIZE_MODAL("disable");

    if (this.idTransformCompletedSale) {
      const data = await this.searchTableDataForSale(
        this.idTransformCompletedSale
      );

      const formatedSale = formatValuesFromSales("Venda", data);

      this.SET_DATA_SEARCH_FROM_SALE(formatedSale);

      this.delayToOpen();
      this.SET_ID_TRANSFORM_COMPLETED_SALE(null);
    }
  },
  async mounted() {
    await this.filterSale(1);
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
  },
};
</script>

<style scoped>
.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 0px;
  height: 100%;
  max-height: 100%;
  overflow: auto;
  width: 100%;
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.closeModalPurchase {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 42%;
  z-index: 900;
  font-size: 10px;
  height: 30px;
  background: white;
  border: 1px solid #ccc;
  border-radius: 0 0 20px 20px;
  color: rgb(6, 6, 6);
}

.closeModalPurchase:hover {
  background: whitesmoke;
  color: red;
}

.closeModalPurchase:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.disable {
  position: absolute;
  width: 100%;
  height: 0;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.MobileGeneral {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 50%, #f8fafc 100%);
  padding-bottom: 80px;
  font-family: "Poppins", sans-serif;
  position: relative;
}

.MobileGeneral::before {
  content: "";
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at 20% 50%,
      rgba(0, 98, 86, 0.05) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(64, 184, 131, 0.05) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 40% 80%,
      rgba(0, 98, 86, 0.03) 0%,
      transparent 50%
    );
  pointer-events: none;
  z-index: -1;
}

.mobile-header {
  padding: 20px 15px 45px 15px;
  width: 100%;
  position: relative;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  color: white;
  transition: all 0.5s ease;
  background: linear-gradient(135deg, #006256 0%, #40b883 50%, #006256 100%);
  background-size: 200% 200%;
  animation: gradientShift 8s ease infinite;
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.mobile-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.1),
    transparent
  );
  animation: shimmer 3s infinite;
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

.BtnRegister {
  width: 180px;
  height: 40px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #006458;
  border: none;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.BtnRegister .b-icon {
  width: 24px !important;
  height: 24px !important;
  background: #006458 !important;
  color: white !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 12px !important;
}

.BtnRegister span {
  width: auto !important;
  font-family: "Poppins", sans-serif;
  letter-spacing: 0.3px;
}

.BtnRegister::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.5s;
}

.BtnRegister:hover::before {
  left: 100%;
}

.BtnRegister:hover {
  background: rgba(255, 255, 255, 1);
  color: #006458;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.BtnRegister:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.header-actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 15px;
}

.btn-toggle-filters {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  color: #006458;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 12px;
  width: 36px;
  height: 36px;
  padding: 0;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
}

.btn-toggle-filters::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: left 0.5s;
}

.btn-toggle-filters:hover::before {
  left: 100%;
}

.btn-toggle-filters:hover {
  background: linear-gradient(135deg, #006256, #40b883);
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(0, 98, 86, 0.25);
}

.btn-toggle-filters:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(0, 98, 86, 0.2);
}

.mobile-filters-container {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 1000;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 20px 15px 25px 15px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 -8px 25px rgba(0, 0, 0, 0.12);
  border-radius: 20px 20px 0 0;
  backdrop-filter: blur(20px);
}

.filter-row {
  margin-bottom: 12px;
}

.filter-row label {
  font-size: 12px;
  color: #374151;
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.date-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.date-group input {
  flex: 1;
  font-size: 13px;
  padding: 10px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
}

.date-group input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.date-separator {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.mobile-select {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 13px;
}

.mobile-select:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.search-row {
  display: flex;
  gap: 8px;
  margin-bottom: 0;
}

.mobile-search-input {
  flex: 1;
  border-radius: 8px;
  height: 40px;
  border: 1px solid rgba(0, 98, 86, 0.2);
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  transition: all 0.3s ease;
  font-size: 13px;
}

.mobile-search-input:focus {
  border-color: #40b883;
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.1);
  outline: none;
}

.btn-search-mobile {
  background: linear-gradient(135deg, #006458, #40b883);
  border: none;
  border-radius: 8px;
  width: 40px;
  height: 40px;
  box-shadow: 0 3px 10px rgba(0, 100, 88, 0.3);
  transition: all 0.3s ease;
}

.btn-search-mobile:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 15px rgba(0, 100, 88, 0.4);
}

.status-scroll-container {
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  padding: 0 15px;
  position: relative;
  margin-top: -30px;
  gap: 8px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.status-scroll-container::-webkit-scrollbar {
  display: none;
}

.status-card {
  min-width: 85px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  padding: 12px 8px;
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.status-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, #40b883, #006256);
  border-radius: 12px 12px 0 0;
}

.status-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
}

.status-card.draft::before {
  background: linear-gradient(90deg, #94a3b8, #64748b);
}

.status-card.finalized::before {
  background: linear-gradient(90deg, #22c55e, #16a34a);
}

.status-card.canceled::before {
  background: linear-gradient(90deg, #ef4444, #dc2626);
}

.status-card.draft .status-label {
  color: #64748b;
  font-weight: 600;
}

.status-card.finalized .status-label {
  color: #16a34a;
  font-weight: 600;
}

.status-card.canceled .status-label {
  color: #dc2626;
  font-weight: 600;
}

.status-label {
  font-size: 10px;
  color: #666;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 4px;
  text-align: center;
}

.status-count {
  font-size: 18px;
  font-weight: 800;
  color: #1a202c;
  font-family: "Poppins", sans-serif;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.card-list-container {
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.sale-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-radius: 12px;
  border: 1px solid rgba(0, 98, 86, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
  padding: 15px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  backdrop-filter: blur(10px);
  cursor: pointer;
}

.sale-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #40b883, #006256);
  border-radius: 0 12px 12px 0;
}

.sale-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 98, 86, 0.1);
  border-color: rgba(0, 98, 86, 0.2);
}

.sale-card:active {
  transform: translateY(-1px);
  border-color: #006458;
  box-shadow: 0 4px 12px rgba(0, 98, 86, 0.15);
}

.card-header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(0, 98, 86, 0.1);
}

.receipt-id {
  font-weight: 800;
  color: #006458;
  font-size: 16px;
  background: linear-gradient(135deg, #006256, #40b883);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.receipt-date {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  background: rgba(0, 98, 86, 0.1);
  padding: 3px 8px;
  border-radius: 12px;
  font-family: "Poppins", sans-serif;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #40b883, #006256);
  box-shadow: 0 0 0 2px rgba(64, 184, 131, 0.3);
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0.7);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(64, 184, 131, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 184, 131, 0);
  }
}

.info-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}

.info-group label {
  font-size: 10px;
  color: #64748b;
  text-transform: uppercase;
  margin: 0 !important;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.info-group strong {
  font-size: 14px;
  color: #1a202c;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.info-group span {
  font-size: 13px;
  color: #374151;
  font-weight: 500;
}

.card-actions-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 98, 86, 0.1);
  margin-top: 12px;
  padding-top: 12px;
  gap: 8px;
}

.action-btn {
  font-size: 11px;
  color: #006458;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 15px;
  background: rgba(0, 98, 86, 0.1);
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 4px;
}

.action-btn:hover {
  color: white;
  background: linear-gradient(135deg, #006256, #40b883);
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(0, 98, 86, 0.3);
}

.action-dropdown .btn {
  padding: 6px !important;
  color: #64748b;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.action-dropdown .btn:hover {
  background: rgba(0, 98, 86, 0.1);
  color: #006458;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f8fffe 0%, #ffffff 100%);
  border-radius: 16px;
  margin: 15px;
  border: 2px dashed rgba(0, 98, 86, 0.2);
}

.empty-state .b-icon {
  color: rgba(0, 98, 86, 0.3);
  margin-bottom: 12px;
}

.empty-state p {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  font-family: "Poppins", sans-serif;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* Estilos dos modais */
.closeModalDetails {
  position: absolute;
  top: 10px;
  right: 15px;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  color: #999;
  z-index: 10;
}

.closeModalDetails:hover {
  color: #333;
}

.contentModal {
  margin-bottom: 20px;
}

.contentModal span {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #006458;
  margin-bottom: 15px;
}

.rowModal {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 15px;
}

.input-group-supplier {
  position: relative;
  margin-bottom: 15px;
}

.input-group-supplier .input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

.input-group-supplier .user-label {
  position: absolute;
  top: -8px;
  left: 10px;
  background: white;
  padding: 0 5px;
  font-size: 11px;
  color: #666;
  font-weight: 600;
}

.titleModal {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.btnModalCancel {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.contentMotivo label {
  font-weight: 600;
  color: #333;
  margin-bottom: 5px;
  display: inline-block;
}

.contentMotivo span {
  color: red;
}

.contentBtns {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.btnContent {
  padding: 10px 20px;
  background: #006458;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btnContent:hover {
  background: #005249;
}

.btnContentReceive {
  padding: 10px 20px;
  background: #f1f1f1;
  color: #333;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btnContentReceive:hover {
  background: #e8e8e8;
}

.alertCancel {
  display: block;
  margin-top: 15px;
  padding: 10px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 6px;
  font-size: 12px;
  color: #856404;
}
</style>
